import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./appLauncher.html";
import { appLauncherItems } from '../../../modules/stores/appLauncherStore';
class AppLauncher extends LightningElement {
  constructor(...args) {
    super(...args);
    this._activeItem = 0;
    this._menuClassName = 'dropdown-apps';
    this._backDropClassName = 'backdrop';
    this._shouldFocusActiveItem = false;
    this.appLauncherMenu = 'applauncher-menu';
    this.appLauncherExpanded = false;
    this.menuItems = [];
  }
  // @ts-expect-error * Automated Type Error Fix
  handleAnalytics(event) {
    let clickUrl = '';
    let clickText = '';
    let menuItem = '';
    let navLevel = '';
    const menuIdentifier = 'waffle';
    const menuTrigger = event.target.querySelector('button');
    if (menuTrigger) {
      menuItem = menuIdentifier;
      clickText = menuIdentifier;
      navLevel = 'l1';
    }
    const menuItemElement = event.target.querySelector('a');
    if (menuItemElement) {
      clickUrl = menuItemElement.href;
      clickText = menuItemElement.textContent?.toLowerCase();
      menuItem = 'waffle:' + clickText;
      navLevel = 'l2';
    }
    const navLink = {
      menuItem: menuItem,
      clickText: clickText,
      clickUrl: clickUrl,
      destinationType: 'internal',
      ctaClick: false,
      navLevel
    };
    event.detail.navLink = navLink;
  }
  get menuClassName() {
    return this._menuClassName + (this.appLauncherExpanded ? ' expanded' : '');
  }
  get backDropClassName() {
    return this._backDropClassName + (this.appLauncherExpanded ? '' : ' hidden');
  }
  getAppLauncherItemsByPosition() {
    return appLauncherItems.sort((prev, current) => prev.position > current.position ? 1 : -1);
  }
  connectedCallback() {
    // @ts-expect-error * Automated Type Error Fix
    this.menuItems = this.getAppLauncherItemsByPosition();
  }
  renderedCallback() {
    if (this.appLauncherExpanded) {
      this.focusDropdown();
    }
    if (this._shouldFocusActiveItem) {
      this.focusActiveItem();
    }
  }
  toogleAppLauncher() {
    this.appLauncherExpanded = !this.appLauncherExpanded;
    if (this.appLauncherExpanded) {
      this.setActiveMenuItem();
    } else {
      this._activeItem = 0;
      this._shouldFocusActiveItem = false;
    }
  }
  focusDropdown() {
    this.template.querySelector('div[data-menu="menu"]').focus();
  }
  focusTrigger() {
    this.template.querySelector('button[data-menu="trigger"]').focus();
  }
  setActiveMenuItem() {
    // @ts-expect-error * Automated Type Error Fix
    this.menuItems = this.menuItems.map(item => {
      return {
        // @ts-expect-error * Automated Type Error Fix
        ...item,
        // @ts-expect-error * Automated Type Error Fix
        active: item.id === this._activeItem
      };
    });
  }
  selectNextMenuItem() {
    this._activeItem++;
    if (this._activeItem > this.menuItems.length) {
      this._activeItem = 1;
    }
    this.setActiveMenuItem();
  }
  selectPreviousMenuItem() {
    this._activeItem--;
    if (this._activeItem < 1) {
      this._activeItem = this.menuItems.length;
    }
    this.setActiveMenuItem();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleTriggerKeyDown(event) {
    if (event.key === 'ArrowDown' || event.key === 'Enter') {
      this._activeItem = 1;
      this._shouldFocusActiveItem = true;
      this.toogleAppLauncher();
      event.preventDefault();
    }
  }
  activateMenuItem() {
    if (this._activeItem > 0) {
      this.template.querySelector('a[data-active="true"]').click();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleMenuKeyDown(event) {
    switch (event.key) {
      case 'Tab':
        this.toogleAppLauncher();
        break;
      case 'Escape':
        this.toogleAppLauncher();
        this.focusTrigger();
        break;
      case 'ArrowDown':
        this.selectNextMenuItem();
        event.preventDefault();
        break;
      case 'ArrowUp':
        this.selectPreviousMenuItem();
        event.preventDefault();
        break;
      case 'Enter':
        this.activateMenuItem();
        break;
      default:
        event.preventDefault();
    }
  }
  focusActiveItem() {
    this.template.querySelector('a[data-active="true"]').focus();
  }
  get menuTriggerClass() {
    return this.appLauncherExpanded ? 'menu__trigger-clicked' : 'menu__trigger';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AppLauncher, {
  fields: ["_activeItem", "_menuClassName", "_backDropClassName", "_shouldFocusActiveItem", "appLauncherMenu", "appLauncherExpanded", "menuItems"]
});
const __lwc_component_class_internal = _registerComponent(AppLauncher, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;